/**
 * Admin ServiceTitan sidebar configuration
 */
export default {
  pathPrefix: 'admin/service_titan',
  items: [
    {
      label: 'Tenants',
      href: '/admin/service_titan/tenants',
      icon: 'fa-solid fa-plug',
      activePath: 'admin/service_titan/tenants'
    }
  ]
}
